<template>
  <v-container class="contView">
    <template v-if="contact">
      <portal to="content-before">
        <OrsInnerToolbar
          :title="`Histórico solicitação ${contact.codigoTarefa}`"
        />
      </portal>
      <v-row align="center">
        <v-col cols="4">
          <v-btn
            text
            x-large
            color="primary"
            class="font-weight-bold"
            :to="{name: 'ContactsList'}"
          >
            <v-icon left>
              mdi-chevron-left
            </v-icon>
            Voltar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <OrsTimeline :dense="$vuetify.breakpoint.smAndDown">
            <OrsTimelineItem
              v-for="(activity, activityIdx) in contact.registroAtividades"
              :key="activityIdx"
              :color="getContactColor(contact)"
            >
              <template #default>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-input label="Atividade">
                      {{ activity.nomeAtividade }}
                    </v-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-input label="Data de início">
                      {{ activity.dataInicialString }}
                    </v-input>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-input label="Prazo">
                      {{ activity.prazoString }}
                    </v-input>
                  </v-col>
                </v-row>
                <!-- eslint-disable vue/no-v-html -->
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-input label="Responsável">
                      <div v-html="activity.responsavel" />
                    </v-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-input label="Contato">
                      <div v-html="activity.descricao" />
                    </v-input>
                  </v-col>
                </v-row>
                <!-- eslint-enable vue/no-v-html -->
              </template>
            </OrsTimelineItem>
          </OrsTimeline>
        </v-col>
      </v-row>
    </template>
    <v-row
      v-else
      justify="center"
    >
      <v-progress-circular
        indeterminate
      />
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import OrsInnerToolbar from '@/components/OrsInnerToolbar.vue';
import OrsTimeline from '../components/OrsTimeline.vue';
import OrsTimelineItem from '../components/OrsTimelineItem.vue';

export default {
  name: 'ContactsView',
  components: {
    OrsInnerToolbar,
    OrsTimeline,
    OrsTimelineItem,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  computed: mapState('views/contactsList', [
    'contact',
    'contacts',
  ]),
  watch: {
    contacts() {
      // FIXME: not so beaulty but works, loadContact when parent contacts changes
      this.loadContact(this.id);
    },
  },
  methods: {
    ...mapActions('views/contactsList', [
      'loadContact',
    ]),
    getContactColor(contact) {
      const { satisfacao } = contact;
      const map = {
        Satisfeito: 'teal',
        Insatisfeito: 'red',
        'Sem Contato': 'orange',
        'Sem contato': 'orange',
      };
      return satisfacao ? map[satisfacao] : 'primary';
    },
  },
};
</script>
